import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  OrganizationMap: {
    height: '150px',
    '& canvas': {
      borderRadius: `5px !important`,
    },
  },
});
